/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-syntax */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    subscription: null,
    subscriptions: [],
    // teamSubscription: null,
    selfSubscription: null,
    selectedType: 'self',
    loading: false
};
const defaultData = {
    type: 'trial',
    credit: {
        keywords: 0,
        replies: 0,
        mentions: 0,
        projects: 0,
        teamMembers: 0,
        storage: 0,
        reports: 0
    },
    platforms: [
        'reddit.com',
        'linkedin.com',
        'twitter.com',
        'quora.com',
        'facebook.com',
        'instagram.com',
        'pinterest.com',
        'tiktok.com',
        'youtube.com',
        'threads.net'
    ],
    remainingCredit: {
        keywords: 0,
        replies: 0,
        mentions: 0,
        projects: 0,
        teamMembers: 0,
        storage: 0,
        reports: 0
    },
    // expire: '2125-01-30T21:19:38.632Z',
    needOpenAiKey: 'Yes'
};
const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        subscriptionInit(state) {
            Object.keys(initialState).map((k) => {
                state[k] = initialState[k];
            });
        },
        getSubscriptionLoading(state, { payload }) {
            state.loading = payload;
        },

        setSubsctription(state, { payload }) {
            const item = payload.item;
            const subscription = Object.keys(item || {}).length ? item : defaultData;
            // state.selfSubscription = subscription;
            state.subscription = subscription;
        },
        // setTeamSubsctription(state, { payload }) {
        //     // state.teamSubscription = payload;
        // },
        setSelfAndTeamSubsctription(state, { payload }) {
            const subscriptions = payload.subscriptions;
            const selfSubscription = subscriptions.find((item) => item.userId === payload.userId);
            state.subscriptions = subscriptions;
            // // if subscriptions length is gratterthan 1 then set team else if selfSubscription.userId is equal to payload.userId then set self else set team
            let selectedType = 'team';

            if (selfSubscription) {
                if (subscriptions.length === 1 && payload.userId === selfSubscription.userId) {
                    selectedType = 'self';
                }
            }
            state.selfSubscription = selfSubscription || defaultData;
            state.selectedType = selectedType;
            // // if selectedType is self then set selfSubscription else set teamSubscription
            state.subscription =
                selectedType === 'self'
                    ? selfSubscription || defaultData
                    : subscriptions.find((item) => item.userId !== payload.userId) || defaultData;
        },
        setSubsctriptionCredits(state, { payload }) {
            const values = payload;
            const types = Object.keys(payload);

            // const { types = [], values = {} } = payload;
            const copy = JSON.parse(JSON.stringify(state.selfSubscription || {}));
            if (!copy?.remainingCredit) {
                return;
            }
            const remCredit = { ...copy.remainingCredit };
            for (const type of types) {
                const val = remCredit[type];
                // console.log({ val });
                if (val !== 'Unlimited') {
                    const upVals = val + values[type];
                    remCredit[type] = upVals < 0 ? 0 : upVals;
                }
            }
            copy.remainingCredit = remCredit;
            // console.log({ copy }, remCredit);
            state.selfSubscription = copy;
        },
        createKeywords(state, { payload }) {
            state.project = { ...state.project, Suggestedkeywords: [...state.project.Suggestedkeywords, ...payload.items] };
        },
        changeSubscriptionSelection(state, { payload }) {
            const subscription = state.subscriptions.find((s) => s.userId === payload);
            state.subscription = subscription || {};
            state.selectedType = state.selfSubscription.userId === payload ? 'self' : 'team';
        }
    }
});

export const {
    hasError,
    createKeywords,
    getSubscriptionLoading,
    setSubsctription,
    setSubsctriptionCredits,
    subscriptionInit,
    // setTeamSubsctription,
    setSelfAndTeamSubsctription,
    changeSubscriptionSelection
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
